module.exports = __webpack_public_path__ + "static/img/failQRCode.9aa9789c.png";